// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"711c0510af779cc2d011","453":"da9ce76c1fcae3597dfb"}[chunkId] + ".js";
};